import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuLinksService } from '@app/services/menu-links.service';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {
    private subs: Subscription;
    menuLinks$: Observable<any[]>;
    currentRoute: string;

    constructor(private menuLinksService: MenuLinksService, private router: Router) {
    }

    ngOnInit(): void {
        this.menuLinks$ = this.menuLinksService.menuLinks$;
        this.subs = this.router.events.subscribe(change => {
            this.currentRoute = this.router.url;
        });

    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
}
